import { Pipe, PipeTransform } from '@angular/core';
import { Icons } from '@ui/shared/model';
import { buildBEMClassNamesByGivenBaseClassAndFlags } from '../utils/class-names';

type IconsUnionType = (typeof Icons)[keyof typeof Icons];

@Pipe({
  name: 'iconClassName'
})
export class IconClassNamePipe implements PipeTransform {
  transform(iconType: IconsUnionType): string {
    return buildBEMClassNamesByGivenBaseClassAndFlags('icon', {
      [iconType]: !!iconType
    });
  }
}
